/**
 * Created by Bob.Gear on 16/04/14.
 */
angular.module("EICDataStream3.pdfReportService", [])
  .config(function () {
  })

  // ReportsController is here to satisfy the top level of the ui-router (don't delete it!)
  .controller('ReportsController',
    [
      '$scope', '$state',
      function ($scope, $state) {
        $scope.componentName = "ReportsController";

        $scope.title = 'Reports';

      }
    ])

  //-------------------------------------------------------------------------
  // Download Reports Controller 'pdfReports' pdfReports,
  //-------------------------------------------------------------------------
  .controller('ManagePdfReportsController',
    [
      '$scope', '$state', '$http', '$interval', 'pdfReportService', 'fileDownloadService',
      function ($scope, $state, $http, $interval, pdfReportService, fileDownloadService) {
        $scope.componentName = "ManagePdfReportsController";

        $scope.title = 'Manage PDF Project Reports';

        $scope.reportStatuses = pdfReportService.reportStatuses

        $scope.viewReport = function (report) {
          pdfReportService.gotoReport(report);
        };



        $scope.isDeleting = false;
        var setDeletingFlag = function (value) {
          $scope.isDeleting = value;
        }
        $scope.btnStartDelete = function () {
          setDeletingFlag(true);
        };
        $scope.btnCancelDelete = function () {
          $scope.reports = $scope.reports.map(function (report) {
            if (report.isDeleting) report.isDeleting = false;
            return report;
          });
          setDeletingFlag(false);
        };

        $scope.btnDownloadPdfReport = function (url) {
          fileDownloadService.downloadFile(url);
        }

        var getReportsList = function () {
          // bail if in the process of editing or deleting
          if ($scope.isDeleting == true) return;

          if ($scope.reports.length == 0) {
            $scope.message = "Fetching reports. Please wait...";
            $scope.messageStyle = "alert alert-warning";
          }

          // Store the list of open items
          var openReportIds = [];
          jQuery(".panel-collapse")
            .each(function (i, e) {
              let elementClasses = e.className.split(' ');
              if (!elementClasses.includes("collapse") || elementClasses.includes("in")) { // || e.hasClass("in")
                openReportIds.push(this.id.split('_')[1]);
              }
            });

          pdfReportService.getReportsList($scope.sort)
            .then(function (response) {
              // ignore the response if the delete button
              // press happened while waiting for a reply
              if ($scope.isDeleting === true) return;
              if ($scope.reports.length === 0) return response.data;

              // if a report is at cancelling status, only let its 
              // status change to cancelled = this debounces the 
              // cancelling/cancelled lag
              var reports = response.data.map(function (newReport) {
                // find report r in $scope reports using its guid
                var currentReport = $scope.reports.find(function (r1) {
                  return (newReport.reportId === r1.reportId);
                });

                if (currentReport.status === $scope.reportStatuses.cancelling &&
                  newReport.status !== $scope.reportStatuses.cancelled) {
                  newReport.status = $scope.reportStatuses.cancelling;
                }


                return newReport;
              });

              return reports;
            })
            .then(
              function (reports) {
                if (!reports) return;
                $scope.reports = reports.map(function (report) {
                  if (openReportIds.includes(report.reportId)) {
                    report.open = true;
                  };
                  return report;
                });

                $scope.message = null;
                $scope.showEditControls = true;
              })
            .catch(function (response) {
              $scope.message = "The reports database is not currently available";
              $scope.messageStyle = "alert alert-danger";
              $scope.showEditControls = false;
            });
        };


        $scope.btnCancelReport = function (report) {
          report.status = $scope.reportStatuses.cancelling;
          pdfReportService.cancelReport(report.reportId);
        };


        $scope.selectForDelete = function (item) {
          var returnClass = {
            'fa fa-circle-thin fa-lg': $scope.isDeleting && !item.isDeleting,
            'fa fa-ban fa-lg': $scope.isDeleting && item.isDeleting,
            'alert-text': item.isDeleting,
            'normal-text': !item.isDeleting
          };

          // var returnClass = "dummyClass";

          // if ($scope.isDeleting) {
          //   returnClass = "fa fa-circle-thin fa-lg";
          // }
          // if ($scope.isDeleting && item.isDeleting) {
          //   returnClass = "fa fa-ban fa-lg";
          // }

          return returnClass;
        };


        //$scope.selectedReports = [];
        //$scope.toggleSelectReport = function(reportId) {
        //  var index = $scope.selectedReports.indexOf(reportId);
        //  if (index === -1) {
        //    $scope.selectedReports.push(reportId);
        //  } else {
        //    $scope.selectedReports.splice(index, 1);
        //  }
        //}


        $scope.btnCancel = function () {
          $scope.isDeleting = false;
          $scope.isEditing = false;
          $scope.reports.map(function (item) {
            item.isDeleting = false;
            item.isEditing = false;
            item.label = item.originalLabel;

          });
        };


        $scope.btnDelete = function () {
          // To give the impression of responsiveness:
          // 1. suspend all updates
          // 2. remove the reports to be deleted from the current list
          // 3. go ahead and delete the records
          // 4. unsuspend updates - if the deletion didn't happen, the report(s) will come back

          // 1. suspend all updates
          setDeletingFlag(true);

          var reportsToDelete = $scope.reports.filter(function (report) {
            return report.isDeleting;
          });


          // 2. remove the reports to be deleted from the current list
          $scope.reports = $scope.reports.filter(function (item) {
            return !(reportsToDelete.find(function (i) { return i.reportId === item.reportId; }));
          });


          // 3. go ahead and delete the records
          pdfReportService.deleteMany(reportsToDelete)
            .then(function () {
              // reset the deleting status when the response comes back
              setDeletingFlag(false);
              getReportsList();
            },
              function (error) {
                // force refresh of the report list
                // May be put an 'incomplete message here
                setDeletingFlag(false);
                getReportsList();
              });
        }


        $scope.noReportsToDelete = function () {
          if (!$scope.isDeleting) return true;

          var any = true;
          $scope.reports.map(function (item) {
            if (item.isDeleting) {
              any = false;
            }
          });
          return any;
        };


        $scope.reports = [];
        $scope.showEditControls = false;




        $scope.runReport = function (reportId) {
          pdfReportService.runReport(reportId)
            .finally(getReportsList);
        };


        var repeat;
        $scope.$on('$viewContentLoaded',
          function () {
            getReportsList();

            repeat = $interval(getReportsList, 5000);
          });

        $scope.$on("SORT_CHANGED", function (e, sort) {
          $scope.sort = sort;
          console.log("Sort Changed to: " + sort.sortField + "  desc:" + sort.sortDesc);
        });

        $scope.$on('$destroy',
          function () {
            $interval.cancel(repeat);
          });
      }
    ])
  .service('pdfReportService',
    [
      "$http", "$q", "$state", function ($http, $q, $state) {
        var pdfReportService = this;


        pdfReportService.reportStatuses = {
          pending: 0,
          queued: 7,
          deferred: 1,
          processing: 2,
          ready: 3,
          failed: 4,
          tooBig: 5,
          stale: 6,
          cancelled: 8,
          cancelling: 9
        };


        this.reportStatusLabel = function (status) {
          switch (status) {
            case 0:
              return 'Pending';
            case 7:
              return 'Queued';
            case 1:
              return 'deferred';
            case 2:
              return 'Processing';
            case 3:
              return 'Ready';
            case 4:
              return 'Failed';
            case 5:
              return 'Too Big';
            case 6:
              return 'Content Stale';
            case 8:
              return 'Cancelled by user';
            case 9:
              return 'Cancelling...';
            default:
              return 'Unknown';
          }
        };


        this.getReportsList = function (sort) {
          var sortQuerystring = "";
          if (sort) sortQuerystring = "?sortField=" + sort.sortField + "&sortDesc=" + sort.sortDesc;
          return $http.get("/api/PdfProjectReport/getreports" + sortQuerystring);
        };

        this.getReport = function (reportId) {
          return $http.get("/api/pdfreport/" + reportId)
            .then(function (response) {
              pdfReportService.report = response.data;

              pdfReportService.initialSort = {
                sortField: pdfReportService.report.sortOrder,
                sortDesc: pdfReportService.report.sortDesc
              };

              return response.data;
            });
        }

        this.gotoReport = function (report) {
          this.report = report;

          this.initialSort = {
            sortField: report.sortOrder || "ProjectName",
            sortDesc: report.sortDesc || false
          };

          $state.go("reports.pdfReport", {
            guid: report.reportId,
            name: report.title.urlEncode()
          });
        };

        this.runReport = function (reportId) {
          return $http.put("/api/pdfprojectreport/runreport/" + reportId,
            { "reportId": reportId, "requestDate": new Date() });
        };

        this.cancelReport = function (reportId) {
          return $http.put("/api/pdfprojectreport/cancel/" + reportId,
            {});
          // { "reportId": reportId, "requestDate": new Date() });
        };

        this.delete = function (reportId) {
          return $http.delete("/api/pdfprojectreport/delete/" + reportId);
        };

        this.deleteMany = function (reports) {
          var urlCalls = reports.map(function (report) {
            return $http.delete("/api/pdfprojectreport/delete/" + report.reportId);

          });


          var deferred = $q.defer();

          $q.all(urlCalls)
            .then(
              function (results) {
                deferred.resolve(
                  JSON.stringify(results));
              },
              function (errors) {
                deferred.reject(errors);
              },
              function (updates) {
                deferred.update(updates);
              });
          return deferred.promise;
        };


        this.removeProjects = function (pdfReportParams) {
          var reportGuid = pdfReportParams.reportGuid;
          var projectIDs = pdfReportParams.projectIDs;
          return $http.patch("/api/pdfreport/" + reportGuid + "?operation=removeProjects", projectIDs);
        }


        this.restoreProject = function (reportGuid, projectId) {
          var projectIds = [];
          projectIds.push(projectId);
          return $http.patch("/api/pdfreport/" + reportGuid + "?operation=restoreProject", projectIds);
        };

        this.addProjects = function (reportGuid, projectIds) {
          return $http.patch("/api/pdfreport/" + reportGuid + "?operation=addProjects", projectIds);
        }


        this.reorderProjects = function (reportGuid, reorderProjects) {
          return $http.put("/api/pdfreport/reorderprojects/" + reportGuid, reorderProjects);
        };


        this.updateProperties = function (reportGuid, report) {
          var reportProperties = {

            reportId: report.reportId,
            title: report.title,
            description: report.description,
            fileName: report.fileName
          }
          return $http.put("/api/pdfreport/updateproperties/" + reportGuid, reportProperties);

        }

      }
    ])
  .controller('ReportRequestController', [
    '$scope',
    '$state',
    '$uibModalInstance',
    'data',
    'pdfReportService',
    'reportRequestService',
    'projectDataService',
    'projectSummarySortService',
    'FEATURE_SWITCHES',
    function ($scope, $state, $uibModalInstance, data, pdfReportService, reportRequestService, projectDataService, projectSummarySortService, FEATURE_SWITCHES) {

      $scope.componentName = "ReportRequestController";
      $scope.NEW_REPORT_REQUEST = FEATURE_SWITCHES.NEW_REPORT_REQUEST;

      $scope.reportParams = data.reportParams;
      $scope.reportParams.projectIds = $scope.reportParams.projects;
      $scope.reportParams.sortOrder = projectSummarySortService.sortOrder;
      $scope.reportParams.sortDesc = projectSummarySortService.sortDesc;

      // --- Handle 'runImmediately selection for new reports --
      $scope.reportParams.runImmediately = true;
      $scope.createReportButtonCaption = "Run Report Now";


      $scope.runImmediatelyChanged = function (runImmediately) {
        $scope.createReportButtonCaption = (runImmediately) ? "Run Report Now" : "Create Report Definition";
        if (runImmediately) {
          $scope.createReportButtonCaption = "Run Report Now";
        }
        else {
          $scope.createReportButtonCaption = "Create Report Definition";
        }
      }
      //----------------------------


      //---- default settings ------
      $scope.reportParams.newReport = true;

      //----------------------------

      $scope.reports = [];

      pdfReportService.getReportsList()
        .then(function (response) {
          var reports = response.data;
          $scope.reports = reports.map(function (report) {
            return {
              reportId: report.reportId,
              title: report.title,
              description: report.description,
              fileName: report.fileName
            };
          });
        });





      $scope.$watch("reportParams.newWatch", function (newVal, oldVal) {
        // bail on the first go through - nothing has happened yet
        if (!newVal && !oldVal) return;

        if (newVal) {
          // clear the select list and description
          // to prepare for a new watch
          $scope.reportParams.selectedProjectWatch = null;
          $scope.reportParams.description = "";
          $scope.reportParams.fileName = "";
        }
        else {
          // clear the text name
          $scope.reportParams.title = "";
          $scope.reportParams.fileName = "";
        }
      });

      $scope.$watch("reportParams.selectedReport", function (newVal, oldVal) {
        if (!newVal) return;

        // when a report is selected, populate the description
        $scope.reportParams.description = newVal.description;
        $scope.reportParams.fileName = newVal.fileName;

      });





      var cloneAndSelectAll = function (sourceObj) {
        var destObj = {};
        angular.copy(sourceObj, destObj);
        angular.forEach(destObj, function (value, key) { value.selected = true; });

        return destObj;
      };

      $scope.noteTypes = cloneAndSelectAll(projectDataService.noteTypes);


      var offsetDays = 0; //159;
      $scope.reportParams.highlightDays = -30 - offsetDays;
      $scope.maxDays = -1 - offsetDays;
      $scope.minDays = -90 - offsetDays;
      $scope.pluralDays = "";

      $scope.projectNotesDuration = {
        option: -1,
        createdWithinMonths: null
      };



      $scope.$watch("projectNotesDuration.createdWithinMonths", function () {
        setProjectNoteCreatedWithinMonths();
      });
      $scope.$watch("projectNotesDuration.option", function () {
        if ($scope.projectNotesDuration.option < 1) $scope.projectNotesDuration.createdWithinMonths = null;

        setProjectNoteCreatedWithinMonths();
      });

      var setProjectNoteCreatedWithinMonths = function () {
        $scope.reportParams.noteAgeMonths = $scope.projectNotesDuration.createdWithinMonths
          || $scope.projectNotesDuration.option;
      }


      $scope.$watch("reportParams.highlightDays", function () {
        if ($scope.reportParams.highlightDays == -1) $scope.pluralDays = "";
        else $scope.pluralDays = "s";
      });


      $scope.selectedNoteTypesChanged = function () {
        var selectedCount = 0;
        // here we form up the list of active note types
        $scope.reportParams.noteTypes = [];
        for (var key in $scope.noteTypes) {
          var item = $scope.noteTypes[key];
          if (item.selected) {
            $scope.reportParams.noteTypes.push(parseInt(item.value, 10));
            selectedCount++;
          }
        }
      };


      var successCallback = function (response) {
        var report = response.data;

        return report;
      };


      var errorCallback = function (response) {
        $scope.success = false;
        $scope.requestSent = true;

        $scope.message = response.statusText;
        $scope.requestSentCloseButtonCaption = "Cancel";
        $scope.messageStyle = { 'color': 'red' };
      };


      var showReportProperties = function (report) {
        $state.go("reports.pdfReport", { guid: report.reportId, name: report.title.urlEncode() });
      };

      $scope.managePdfReports = function () {
        $state.go("reports.managePdfReports");
      };

      var closeDialog = function () {
        $uibModalInstance.dismiss('Canceled');
      };


      $scope.cancel = function () {
        closeDialog();
      }
      //$scope.submitReportRequest = function () {
      //  // as per John Papa, don't make the http call directly. Set up and
      //  // inject a service to  do  this so that  the controller is not
      //  // polluted with things that  are not its direct concern.
      //  // this has the by-product of making the controller instantly more testable.
      //  // this same principle should probably be extended to  handling the dialog
      //  $scope.reportParams.fileName = $scope.reportParams.fileName + ".pdf";

      //  var report = reportRequestService.submitReportRequest($scope.reportParams)
      //    .then(successCallback, errorCallback);
      //};

      //      $scope.saveReportRequest = function() {
      //// This is a change to the way the service works
      //        // Instead of immedately submitting the report, we instead go to the manage 
      //        // report page where the report contents, sort order etc can be inspected 
      //        // prior to the report being run.
      //        // If tis is adding additional projects, we could divert straight to the 
      //        // report page
      //        // Note to self - will I get a report ID back from this save operation?, errorCallback

      //        reportRequestService.saveReportRequest($scope.reportParams)
      //          .then(successCallback)
      //          .then(showReportProperties)
      //          .then(closeDialog);
      //      };

      var runReport = function (report) {
        pdfReportService.runReport(report.reportId);
      };


      var showSuccessDialog = function () {
        $scope.success = true;
        $scope.requestSent = true;

        $scope.message = "Your Report Request has been placed on the queue. You will be notified by email when your report is ready for download";
        $scope.requestSentCloseButtonCaption = "OK";
        $scope.messageStyle = { 'color': 'black' };
      };

      $scope.downloadTest = function () {
        console.log("Download Test");
        reportRequestService.downloadTest($scope.reportParams);
      };
      $scope.createReport = function () {
        $scope.reportParams.sortOrder = projectSummarySortService.sortOrder;
        $scope.reportParams.sortDesc = projectSummarySortService.sortDesc;

        if ($scope.reportParams.runImmediately) {
          reportRequestService.createReport($scope.reportParams)
            .then(successCallback) //, errorCallback)
            .then(runReport)
            .then(showSuccessDialog)
            .catch(errorCallback);
        }
        else {
          reportRequestService.createReport($scope.reportParams)
            .then(successCallback) //, errorCallback)
            .then(showReportProperties)
            .then(closeDialog)
            .catch(errorCallback);
        }

      };


      $scope.addProjects = function (projectIds) {
        var selectedReport = $scope.reportParams.selectedReport;
        pdfReportService.addProjects(selectedReport.reportId, projectIds)
          .then(successCallback)
          .then(showReportProperties)
          .then(closeDialog)
          .catch(errorCallback);

      }


      $scope.updateReport = function () {
        reportRequestService.updateReport($scope.reportParams)
          .then(successCallback)
          .then(showReportProperties)
          .then(closeDialog)
          .catch(errorCallback);
      };


      $scope.hitEnter = function (evt) {
        if (angular.equals(evt.keyCode, 13) && !(angular.equals($scope.user.name, null) || angular.equals($scope.user.name, '')))
          $scope.save();
      };


      $scope.$watch("reportParams.title", function () {
        if (!$scope.reportDialog.txtFileName) return;
        if ($scope.reportDialog.txtFileName.$pristine) {
          // replace any illegal file characters with "_" and spaces with "-"
          $scope.reportParams.fileName = $scope.reportParams.title
            .replace(/[\\\/:*?"<>|]{1,}/g, "_")
            .replace(/[ ]{1,}/g, "-")
            //.replace(/[_]|(.)\1/g, "_")
            //.replace(/[-]\1/g, "-")
            ;
        }

      }, true);

      $scope.selectedNoteTypesChanged();
      $scope.$on('$viewContentLoaded', function () {
      });

    }
  ])
  .service('reportRequestService', [
    '$http', 'dialogService', 'projectDataService', 'trackingStatusService',
    function ($http, dialogService, projectDataService, trackingStatusService) {

      //////////////////////////////////////////////////////////////////////
      ////  Open dialog for New Report Request - Selected Projects
      //////////////////////////////////////////////////////////////////////

      this.openReportRequestDialog_selectedProjects = function () {



        var projectIDs = getSelectedProjectIDs();

        // HACK ALERT
        // if no projects have been explicitly chosen, then select all
        // those that  match the TrackingStatus selection
        if (projectIDs.length == 0) {
          projectIDs = getAllVisibleProjectIDs();
        }

        var reportParams = {
          title: "",
          description: "",
          fileName: "",
          highlightDays: 28,

          sort: {
            order: "ProjectName",
            direction: "ASC",
            pageBreak: false
          },
          criteria: "",
          projects: projectIDs,
          noteTypes: [],
          trackingStatuses: []

        };


        dialogService.openReportRequestDialog(reportParams);
      };

      this.openReportRequestDialog_singledProject = function (project) {

        var reportParams = {
          title: project.projectName.substring(0, 49),
          description: project.projectName,
          fileName: project.projectName.substring(0, 49).urlEncode() + '.pdf',
          highlightDays: 28,

          sort: {
            order: "ProjectName",
            direction: "ASC",
            pageBreak: false
          },
          criteria: "",
          projects: [project.projectID],
          noteTypes: [],
          trackingStatuses: []

        };

        dialogService.openReportRequestDialog(reportParams);
      };


      //////////////////////////////////////////////////////////////////////
      ////  Report Request Support Functions
      //////////////////////////////////////////////////////////////////////

      var getSelectedProjectIDs = function () {
        return projectDataService.projectNames
          .filter(function (item, index, ar) {
            if (item.isChecked) return true;
          }
          ).map(function (item, index, ar) {
            return item.projectID;
          }
          );
      };

      var getAllVisibleProjectIDs = function () {
        return projectDataService.projectNames
          .filter(function (item, index, ar) {
            if (trackingStatusService.selectedValues.indexOf(item.trackingStatusID) > -1) return true;
          })
          .map(function (item, index, ar) {
            return item.projectID;
          }
          );
      };

      //////////////////////////////////////////////////////////////////////
      this.createReport = function (reportParams) {
        return $http.post('/api/pdfprojectreport/create', reportParams);
        //    return $http.post('/api/enqueueReport', reportParams);
      };

      this.updateReport = function (reportParams) {
        return $http.put('/api/pdfprojectreport/update/' + reportParams.reportId, reportParams);
        //    return $http.post('/api/enqueueReport', reportParams);
      };

      this.downloadTest = function (reportParams) {
        console.log("about to send the request");

        return $http.post('/api/requestprojectexport',
          { projectIds: [1, 2, 3] },
          { responseType: "blob" })
          .then(function (response) {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(response.data);
            link.download = "Report.xlsx";
            //  link.setAttribute('download', 'file.xlsx');
            //  document.body.appendChild(link);
            link.click();
          });


        //, {
        //  IncludeContractors: true,
        //  ProjectIds: [1, 2, 3]
        //});
        //    return $http.post('/api/enqueueReport', reportParams);
      };

    }
  ])




  //-------------------------------------------------------------------------
  // Insight Reports Controller
  //-------------------------------------------------------------------------
  .controller('InsightReportsController', ['$scope', '$state', '$http', '$interval', 'pdfReports',
    function ($scope, $state, $http, $interval, pdfReports) {
      $scope.componentName = "InsightReportsController";

      $scope.title = 'Insight Reports';


      // Download the report by calling the api - probably should refactor this into a service.
      // the API will use currentUser login details to log the download.
      $scope.doDownload = function (insightReportID) {
        $http.get("/api/InsightReports/?insightID=" + insightReportID);
      };

    }])


  //-------------------------------------------------------------------------
  // Sector Workbooks Controller
  //-------------------------------------------------------------------------
  .controller('SectorWorkbooksController', ['$scope', '$state',
    function ($scope, $state) {
      $scope.componentName = "SectorWorkbooksController";

      $scope.title = 'Sector Workbooks';


      // Download the report by calling the api - probably should refactor this into a service.
      // the API will use currentUser login details to log the download.
      $scope.doDownload = function (sectorWorkbookID) {
        $http.get("/api/SectorWorkbooks/?SectorWorkbookID=" + sectorWorkbookID);
      };

    }]);
